function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationTruckRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 26a1 1 0 112 0 1 1 0 01-2 0zm8-22H5c-1.1 0-2 .9-2 2v19c0 1.1.9 2 2 2h2.184A2.99 2.99 0 0010 29a2.99 2.99 0 002.816-2H19V6c0-1.1-.9-2-2-2zM23 18v-6h1.764l3 6H23zm2 9a1 1 0 110-2 1 1 0 010 2zm0-19h-4v19h1.184A2.99 2.99 0 0025 29a2.99 2.99 0 002.816-2H28a2 2 0 002-2v-7L25 8z",
    fill: props.color
  }));
}

export default SvgIconTransportationTruckRexFilled;